import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import Cup from '../assets/cup-o-design-tools.svg';
import Envelope from '../assets/envelope.svg';
import Graph from '../assets/graph.svg';

export default () => (
  <StaticQuery
    query={graphql`
      query {
        emailSettings: file(relativePath: { eq: "email-settings-zoom.png" }) {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        dashboard: file(relativePath: { eq: "dashboard-zoom-2.png" }) {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        response: file(relativePath: { eq: "response-form.png" }) {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <div className="bg-gray-100 py-8">
        <div className="container text-center mt-6 mb-12">
          <h2 className="leading-none md:leading-normal font-sans text-shop-dark-green text-4xl">
            So, how does it work?
          </h2>
        </div>

        <div className="container flex flex-row flex-wrap mb-32 items-center">
          <div className="w-full md:w-1/2 content-center justify-center flex mb-8 sm:mb-0">
            <div className="w-full md:w-3/4 shadow-lg rounded-lg content-center flex-col text-center overflow-hidden">
              <Img fluid={data.emailSettings.childImageSharp.fluid} />
            </div>
          </div>
          <div className="w-full md:w-1/2 sm:pl-8">
            <h2 className="leading-normal font-sans text-2xl text-shop-dark-green">
              1. Customize Email
            </h2>
            <p className="leading-normal font-sans text-shop-dark-green mt-4 md:w-3/4">
              The surveys are sent out automatically to your customers via a
              customizable email. Upload your logo, change colors, and match
              your brand's identity. Customize the days after purchase to insure
              your customer has time to spend with your product. Prevent over
              surveying your customers with Survey Throttling.
            </p>
          </div>
        </div>

        <div className="container flex flex-row-reverse flex-wrap mb-32 items-center">
          <div className="w-full md:w-1/2 content-center justify-center flex mb-8 sm:mb-0">
            <div className="w-full md:w-3/4 shadow-lg rounded-lg content-center flex-col text-center overflow-hidden">
              <Img fluid={data.response.childImageSharp.fluid} />
            </div>
          </div>
          <div className="w-full md:w-1/2 sm:pl-8">
            <h2 className="leading-normal font-sans text-2xl text-shop-dark-green">
              2. Customers takes a single question survey
            </h2>
            <p className="leading-normal font-sans text-shop-dark-green mt-4 md:w-3/4">
              Your customers will answer the survey and provide valuable
              feedback about their experience with your shop.
            </p>
          </div>
        </div>

        <div className="container flex flex-row flex-wrap mb-32 items-center">
          <div className="w-full md:w-1/2 content-center justify-center flex mb-8 sm:mb-0">
            <div className="w-full md:w-3/4 shadow-lg rounded-lg content-center flex-col text-center overflow-hidden">
              <Img fluid={data.dashboard.childImageSharp.fluid} />
            </div>
          </div>
          <div className="w-full md:w-1/2 sm:pl-8">
            <h2 className="leading-normal font-sans text-2xl text-shop-dark-green">
              3. Get Actionable Feedback
            </h2>
            <p className="leading-normal font-sans text-shop-dark-green mt-4 md:w-3/4">
              Find out what your customers like and dislike about your shop and
              brand. Overtime your goal should be to increase your overall NPS
              score, which in turn creates happier customers and improves your
              sales.
            </p>
          </div>
        </div>
      </div>
    )}
  />
);
